import { getThemeAssetUrl } from "../utils/themeAssets";
import "./PaymentMethods.css";

type PaymentMethod = {
  id: string;
  imageUrl: string;
  label: string;
};

const paymentMethods: PaymentMethod[] = [
  {
    id: "paypal",
    imageUrl: getThemeAssetUrl("payment-methods-paypal.png"),
    label: "PayPal",
  },
  {
    id: "mastercard",
    imageUrl: getThemeAssetUrl("payment-methods-mastercard.png"),
    label: "Mastercard",
  },
  {
    id: "visa",
    imageUrl: getThemeAssetUrl("payment-methods-visa.png"),
    label: "Visa",
  },
  {
    id: "apple-pay",
    imageUrl: getThemeAssetUrl("payment-methods-apple.png"),
    label: "Apple Pay",
  },
];

export function PaymentMethods() {
  return (
    <div className="react-pdp__payment-methods" aria-label="Zahlungsarten">
      {paymentMethods.map((method) => (
        <img
          alt={method.label}
          className={`react-pdp__payment-method-image react-pdp__payment-method-image--${method.id}`}
          key={method.id}
          src={method.imageUrl}
        />
      ))}
    </div>
  );
}
